import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { getAllWorkspaceTeams, ITeam } from 'wisestep-api';
import { ScrollableTabs } from 'wisestep-base';

import { IWorkAssignments } from '../../types';
import AssignedTeamsList from '../AssignedTeamsList';
import TeamsList from '../TeamsList';

interface IWorkspaceTeamsResponse {
  teams: ITeam[];
  assignedTeamsIds: string[];
}

export interface IWorkspaceTeamsTable {
  workAssignments: IWorkAssignments;
  jobId: string;
  refreshAssignments(): void;
}

const WorkspaceTeamsTable = ({
  workAssignments,
  jobId,
  refreshAssignments,
}: IWorkspaceTeamsTable) => {
  const methods = useForm();

  const [tabPanelPage, setTabPanelPage] = useState(0);

  const [workspaceTeamsResponse, setWorkspaceTeamsResponse] = useState<IWorkspaceTeamsResponse>({
    teams: [],
    assignedTeamsIds: [],
  });

  useEffect(() => {
    const getTeamsAndRecruiters = async () => {
      const workspaceTeamsResponse = await getAllWorkspaceTeams();
      if (workspaceTeamsResponse) {
        const teams: ITeam[] = workspaceTeamsResponse.data;

        // filtering assigned teams ids from teams array to pre-check in the Choose Teams tab
        const assignedTeams: string[] = [];
        teams.forEach((team) => {
          const foundTeam = workAssignments.teams.find((t) => t.id === team.id);
          if (foundTeam?.id) assignedTeams.push(foundTeam.id);
        });
        setWorkspaceTeamsResponse({ teams: teams, assignedTeamsIds: assignedTeams });
      }
    };
    getTeamsAndRecruiters();
  }, [jobId, workAssignments]);

  const onAssign = () => {
    refreshAssignments();
    setTabPanelPage(1);
  };
  return (
    <>
      <ScrollableTabs
        scrollList={[
          { tabName: 'Choose Teams' },
          {
            tabName: 'Assigned',
            tabCount: workAssignments.teams?.length ?? 0,
          },
        ]}
        getTabIndex={setTabPanelPage}
        defaultValue={tabPanelPage}
      />

      <FormProvider {...methods}>
        {tabPanelPage === 0 && (
          <Grid container p={2} mb={5}>
            {workspaceTeamsResponse && (
              <TeamsList
                teamsData={workspaceTeamsResponse.teams}
                jobIds={[jobId]}
                onAssign={onAssign}
                preCheckedTeamIds={workspaceTeamsResponse.assignedTeamsIds}
              />
            )}
          </Grid>
        )}
        {tabPanelPage === 1 && (
          <Grid container p={2}>
            <AssignedTeamsList
              workAssignments={workAssignments}
              jobId={jobId}
              refreshJob={() => refreshAssignments()}
            />
          </Grid>
        )}
      </FormProvider>
    </>
  );
};

export default WorkspaceTeamsTable;
